export { default } from "./TrainingVideos";
export { default as TrainingVideosPage } from "./TrainingVideos";
